import { useRef, MutableRefObject } from 'react';
import { useUpdateEffect, useUnmount } from 'ahooks';
import ImgsLazyObserver from 'common/src/services/intersectionObserve/imgsLazyObserver';

/**
 * 用于懒加载图片
 * @param url 图片URL
 * @param lazyOptions IntersectionObserver的配置项
 * @returns 绑定到图片元素的ref回调函数
 */
export const useLazyLoadImg = (url: string, lazyOptions: Partial<IntersectionObserverInit> = {}) => {
    const $ele = useRef<HTMLElement | null>(null);
    const observerRef: MutableRefObject<ImgsLazyObserver> = useRef(ImgsLazyObserver.getObserver(lazyOptions));

    const observe = () => {
        observerRef.current?.observe($ele.current!);
    };

    useUnmount(() => {
        $ele.current && observerRef.current?.unobserve($ele.current);
    });

    useUpdateEffect(() => {
        const node = $ele.current;
        if (!node) {
            return;
        }
        if (!!node.classList.contains('lazy-loaded')) {
            ImgsLazyObserver.setImgUrl(node, url);
            return;
        }
        node.setAttribute('data-src', url);
    }, [url]);

    return (node: HTMLImageElement | null) => {
        if (node) {
            $ele.current = node;
            observe();
        }
    };
};
